var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33594 5.14706H16.6693M8.33594 13.9706V8.67647M11.6693 13.9706V8.67647M13.3359 17.5H6.66927C5.7488 17.5 5.0026 16.7099 5.0026 15.7353V6.02941C5.0026 5.5421 5.3757 5.14706 5.83594 5.14706H14.1693C14.6295 5.14706 15.0026 5.5421 15.0026 6.02941V15.7353C15.0026 16.7099 14.2564 17.5 13.3359 17.5ZM8.33594 5.14706H11.6693C12.1295 5.14706 12.5026 4.75202 12.5026 4.26471V3.38235C12.5026 2.89504 12.1295 2.5 11.6693 2.5H8.33594C7.8757 2.5 7.5026 2.89504 7.5026 3.38235V4.26471C7.5026 4.75202 7.8757 5.14706 8.33594 5.14706Z",
    stroke: "#BC1C1C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashRed);
export default __webpack_public_path__ + "static/media/trashRed.cd34b3c2679bede62cde415636e62c95.svg";
export { ForwardRef as ReactComponent };